import { Paper, Typography, CircularProgress, Chip, Box } from "@mui/material";
import main from "../../assets/scss/main.module.scss";
import { Balance } from "../common/Balance";
import { useCustomerInfoContext } from "../../context/CustomerInfoContext";
import { useState, useEffect } from "react";
import { RewardData, UsedRewardData } from "../../type";
import CustomAxios from "../../utils/CustomAxios";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import { ChangeModal } from "./ChangeModal";

const REGION = process.env.REACT_APP_REGION as string;

export const Change = () => {
  const { pointData } = useCustomerInfoContext();

  const [rewardDataList, setRewardDataList] = useState<RewardData[]>([]);
  const [usedRewardDataList, setUsedRewardDataList] = useState<
    UsedRewardData[]
  >([]);
  const [selectReward, setSelectReward] = useState<RewardData>();
  const [isRewardLoading, setIsRewardLoading] = useState<boolean>(false);
  const [isUsedRewardLoading, setIsUsedRewardLoading] =
    useState<boolean>(false);
  const [isPointSpendModalOpen, setIsPointSpendModalOpen] =
    useState<boolean>(false);

  useEffect(() => {
    setIsRewardLoading(true);
    CustomAxios.get("/rewards", { params: { region: REGION } })
      .then((res) => {
        setRewardDataList(res.data.rewards);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRewardLoading(false);
      });

    getUsedRewardData();
  }, []);

  const getUsedRewardData = () => {
    setIsUsedRewardLoading(true);
    CustomAxios.get("/customer/rewards")
      .then((res) => {
        setUsedRewardDataList(res.data.rewards);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsUsedRewardLoading(false);
      });
  };

  const handleReward = (item: RewardData) => {
    setIsPointSpendModalOpen(true);
    setSelectReward(item);
  };

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          backgroundColor: main.colorLightGreen,
          py: 2,
          mt: "110px",
          mb: 2,
        }}
      >
        <Paper
          elevation={1}
          sx={{ width: "90%", mx: "auto", p: 2, borderRadius: "16px" }}
        >
          <Balance type="point" />
        </Paper>
      </Paper>

      <Typography sx={{ my: 2 }}>
        下記から交換したい景品を選んでください
      </Typography>
      {isRewardLoading && <CircularProgress />}
      {!isRewardLoading &&
        rewardDataList.map((item, index) => (
          <Paper
            key={index}
            onClick={() => handleReward(item)}
            sx={{
              m: 2,
              px: 1,
              py: 2,
              textAlign: "left",
              cursor: "pointer",
            }}
          >
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                m: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <LoyaltyIcon
                  fontSize="large"
                  sx={{ mr: 2, color: main.colorDarkGreen }}
                />
                <Box>
                  <Typography sx={{ fontSize: "20px" }}>{item.name}</Typography>
                  <Typography sx={{ fontSize: "14px" }}>
                    {item.issuerName}
                  </Typography>
                </Box>
              </Box>
              <Paper
                elevation={0}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ display: "inline", fontWeight: "bold", mx: 1 }}
                >
                  {item.point}
                </Typography>
                pt
              </Paper>
            </Paper>
            <Paper elevation={0} sx={{ textAlign: "right" }}>
              {pointData < item.point ? (
                <Chip
                  label={"ポイントが足りません"}
                  color="error"
                  size="small"
                  sx={{ color: "#FFF", ml: 4, px: 2 }}
                />
              ) : (
                ""
              )}
            </Paper>
          </Paper>
        ))}

      <Typography sx={{ my: 2 }}>交換済み景品</Typography>
      {isUsedRewardLoading && <CircularProgress />}
      {!isUsedRewardLoading &&
        usedRewardDataList.map((item, index) => (
          <Paper
            key={index}
            sx={{
              m: 2,
              px: 1,
              py: 2,
              textAlign: "left",
              backgroundColor: item.availableFlag ? "white" : "lightGray",
            }}
          >
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                m: 2,
                backgroundColor: "transparent",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <LoyaltyIcon
                  fontSize="large"
                  sx={{ mr: 2, color: main.colorDarkGreen }}
                />
                <Box>
                  <Typography sx={{ fontSize: "20px" }}>{item.name}</Typography>
                  <Typography sx={{ fontSize: "14px" }}>
                    {item.issuerName}
                  </Typography>
                </Box>
              </Box>
              <Paper
                elevation={0}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "transparent",
                }}
              >
                <Typography
                  sx={{
                    display: "inline",
                    fontSize: "24px",
                    fontWeight: "bold",
                    mx: 1,
                  }}
                >
                  {item.point}
                </Typography>
                pt
              </Paper>
            </Paper>
            {item.availableFlag ? (
              ""
            ) : (
              <Paper elevation={0} sx={{ backgroundColor: "transparent" }}>
                <Chip
                  label={"使用済み"}
                  color="info"
                  size="small"
                  sx={{ color: "#FFF", ml: 1, px: 2 }}
                />
                <Typography sx={{ ml: 1, display: "inline" }}>
                  {item.usedAt}
                </Typography>
              </Paper>
            )}
          </Paper>
        ))}

      <ChangeModal
        isPointSpendModalOpen={isPointSpendModalOpen}
        setIsPointSpendModalOpen={setIsPointSpendModalOpen}
        selectReward={selectReward}
        getUsedRewardData={getUsedRewardData}
      />
    </>
  );
};
